module.exports = __webpack_public_path__ + "static/media/264.ec55f969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/264.jpg
// module id = 969
// module chunks = 0